import React, { useEffect, useState } from 'react';
import intl from 'react-intl-universal';
import { Button, Modal } from 'antd';
import './header.scss';
import { fileController } from 'Components/viewer/Controllers';
import { getDriveRefreshCode, encryptAES, storageSetItem, lmsGetCwsDomain } from 'Utils/utils';
import { lmsApi } from '@/api';
import _get from 'lodash/get';

window.needRefresh = false;
const LMSSubBtn = (props) => {
  const { store } = props;
  const [btnKey, setBtnKey] = useState(`bk_${Math.random()}`);

  // 提交的时候，所需要的所有平台传回来的信息，从这里个面去获取。
  const getCurFileInfoFromLocal = () => {
    const res = JSON.parse(window.localStorage.getItem('lms_cur_file_info') || '{}');
    return res;
  };

  const hasSubEd = () => {
    const { ext_lti_assignment_id } = getCurFileInfoFromLocal();
    const res = localStorage.getItem(ext_lti_assignment_id) === 'y';
    return res;
  };

  const getSubBtnTip = () => {
    const btnTipKey = hasSubEd() ? 'account.unSubmit' : 'account.submit';
    const btnTip = intl.get(btnTipKey);
    return btnTip;
  };

  const checkFolderExist = async ({ driveName, folderName, parentId }) => {
    const res = await store.driveStore.doListFolder({ driveName, folderName, parentId });
    if (res.files && res.files.length) {
      return res.files[0];
    }
    return null;
  };

  const checkFileExist = async ({ driveName, parentId, fileName }) => {
    const res = await store.driveStore.doListFiles({ driveName, parentId, fileName });
    if (res.files && res.files.length) {
      return res.files[0];
    }
    return null;
  };

  const createFolder = async () => {
    const { driveName, custom_context_title, custom_canvas_assignment_title } = getCurFileInfoFromLocal();
    // Foxit Cloud 全局文件夹不能改变
    let globalFolder = await checkFolderExist({
      driveName,
      folderName: 'Foxit Cloud',
      parentId: 'root',
    });
    if (!globalFolder) {
      const res = await store.driveStore.doCreateFolder({
        driveName,
        folderName: 'Foxit Cloud',
        folderPath: [{ id: null, name: driveName }],
      });
      if (res.id) {
        globalFolder = res;
      }
    }

    let courseFolder = await checkFolderExist({
      driveName,
      folderName: custom_context_title,
      parentId: globalFolder.id,
    });
    if (!courseFolder) {
      const res = await store.driveStore.doCreateFolder({
        driveName,
        folderName: custom_context_title,
        folderPath: [{ id: globalFolder.id, name: driveName }],
      });
      if (res.id) {
        courseFolder = res;
      }
    }

    let assignmentFolder = await checkFolderExist({
      driveName,
      folderName: custom_canvas_assignment_title,
      parentId: courseFolder.id,
    });
    if (!assignmentFolder) {
      const res = await store.driveStore.doCreateFolder({
        driveName,
        folderName: custom_canvas_assignment_title,
        folderPath: [{ id: courseFolder.id, name: driveName }],
      });
      if (res.id) {
        assignmentFolder = res;
      }
    }
    return [globalFolder, courseFolder, assignmentFolder];
  };

  const getFileBlob = async () => {
    const fileBuffer = (await fileController.getCurrentDocBuffer())[0];
    let blob = new Blob(fileBuffer, { type: 'application/pdf' });
    const { lis_person_name_full: studentName, roles } = getCurFileInfoFromLocal();
    const docFileName = await fileController.getFileName();
    if (roles && roles === 'Learner') {
      blob.name = `${studentName} - ${docFileName}`;
    } else {
      blob.name = docFileName;
    }
    return blob;
  };

  const subToPlatformHandle = async (lmsSelFile = '') => {
    const {
      lis_outcome_service_url,
      lis_result_sourcedid,
      oauth_consumer_key,
      oauth_signature_method,
      oauth_timestamp,
      oauth_nonce,
      oauth_version,
    } = getCurFileInfoFromLocal();
    const cwsApiUrl = await lmsGetCwsDomain();
    const resUrl = `${cwsApiUrl}/cpdfapi/v1/lms/transfer?lmsSelFile=${lmsSelFile}`;
    const token = window.localStorage.getItem('driver_access_token_for_auto_login') || store.userStore.token;
    const resData = await lmsApi.subAssignment({
      token,
      type: hasSubEd() ? 2 : 1, //1 submit,  2 unSubmit
      ltiLaunchUrl: resUrl,
      lis_outcome_service_url,
      lis_result_sourcedid,
      oauth_consumer_key,
      oauth_signature_method,
      oauth_timestamp,
      oauth_nonce,
      oauth_version,
    });
    return resData;
  };

  const sendBackToPlatform = async (fileInfo, success, fail) => {
    const {
      createdTime,
      id,
      mimeType,
      modifiedTime,
      name,
      size,
      webContentLink,
      webViewLink,
    } = fileInfo;
    const refreshCode = getDriveRefreshCode('google');
    const {
      driveName,
      ext_lti_assignment_id,
    } = getCurFileInfoFromLocal();
    const lmsSelFile = await encryptAES(JSON.stringify({
      item: {
        createdTime,
        id,
        mimeType,
        modifiedTime,
        name,
        size,
        webContentLink,
        webViewLink,
        originSize: size,
      },
      driveName,
      refreshCode,
    }), 'abcdefg123456789', '');
    try {
      const resData = await subToPlatformHandle(lmsSelFile);
      if (_get(resData, 'data.imsx_codeMajor') === 'success') {
        localStorage.setItem(ext_lti_assignment_id, 'y');
        setBtnKey(`bk_${Math.random()}`);
        success && success();
      } else {
        fail && fail();
      }
    } catch (e) {
      fail && fail();
    }
  };

  const btnHandle = async () => {
    // oauth_nonce,oauth_timestamp 参数使用一次，需要平台再次更新才行
    if (window.needRefresh) {
      Modal.info({
        title: intl.formatMessage({ id: 'pleaseNote' }),
        content: intl.formatMessage({ id: 'fileStateChange' }),
        className: 'refresh-tip',
      });
      return;
    }

    window.needRefresh = true;
    store.appStore.showLoading(true);

    if (hasSubEd()) {
      // unsubmit -> remove assignment
      const { ext_lti_assignment_id } = getCurFileInfoFromLocal();
      try {
        const resData = await subToPlatformHandle();
        store.appStore.showLoading(false);
        if (_get(resData, 'data.imsx_codeMajor') === 'success') {
          localStorage.setItem(ext_lti_assignment_id, 'n');
          setBtnKey(`bk_${Math.random()}`);
          store.appStore.setGlobalMessage({
            type: 'success',
            content: intl.formatMessage({ id: 'unSubmit.suc' }),
          });
        } else {
          store.appStore.setGlobalMessage({
            type: 'error',
            content: intl.formatMessage({ id: 'unSubmit.fail' }),
          });
        }
      } catch (e) {
        store.appStore.showLoading(false);
        store.appStore.setGlobalMessage({
          type: 'error',
          content: intl.formatMessage({ id: 'unSubmit.fail' }),
        });
      }
      return;
    }

    // when student un/submit assignment,the token may have expired
    const refresh_code = getDriveRefreshCode('google');
    const { driveName } = getCurFileInfoFromLocal();
    if (refresh_code) {
      const result = await store.driveStore.initTokenByRefreshToken({ driveName, refreshToken: refresh_code });
      if (result && result.access_token) {
        storageSetItem(localStorage, 'GoogleDriveAccessToken', result.access_token);
      }
    }

    const success = (res) => {
      // to send back to platform like: Canvas
      sendBackToPlatform(res, () => {
        store.appStore.showLoading(false);
        store.appStore.setGlobalMessage({
          type: 'success',
          content: intl.formatMessage({ id: 'submit.suc' }),
        });
      }, () => {
        store.appStore.showLoading(false);
        store.appStore.setGlobalMessage({
          type: 'error',
          content: intl.formatMessage({ id: 'submit.fail' }),
        });
      });
    };

    const fail = (error) => {
      store.appStore.showLoading(false);
      if (error.errorMsg != undefined && error.errorMsg != '') {
        store.appStore.setGlobalMessage({ type: 'error', content: error.errorMsg });
      } else {
        store.appStore.setGlobalMessage({ type: 'error', content: intl.formatMessage({ id: 'submit.fail' }) });
      }
    };

    try {
      // to drive
      const folderPath = await createFolder();
      const fileBlob = await getFileBlob();
      const { driveName } = getCurFileInfoFromLocal();
      let fileExist = await checkFileExist(
        { driveName, parentId: folderPath[folderPath.length - 1].id, fileName: fileBlob.name });

      if (!fileExist) {
        store.driveStore.doCreateFile({
          driveName,
          fileBlob,
          folderPath,
          mimeType: 'application/pdf',
          fileType: 'pdf',
          success: (res) => {
            success(res);
          },
          fail: (error) => {
            fail(error);
          },
        });
      } else {
        store.driveStore.doUpdateFile({
          driveName,
          fileBlob,
          record: { ...fileExist, name: fileBlob.name, mimeType: 'application/pdf', fileType: 'pdf' },
          success: (res) => {
            success(res);
          },
          fail: (error) => {
            fail(error);
          },
        });
      }
    } catch (e) {
      store.appStore.showLoading(false);
      fail(e);
    }
  };

  const isStudent = () => {
    const { roles = '', lis_outcome_service_url = '' } = getCurFileInfoFromLocal();
    if (roles === 'Learner' && lis_outcome_service_url) {
      return true;
    }
    return false;
  };

  const updateFileByTeacher = () => {
    const fn = async () => {
      const { driveName, id } = getCurFileInfoFromLocal();
      const fileBlob = await getFileBlob();
      try {
        store.driveStore.doUpdateFile({
          driveName,
          fileBlob,
          record: { id, name: fileBlob.name, mimeType: 'application/pdf', fileType: 'pdf' },
        });
      } catch (e) {
        throw e;
      }
    };
    fn();
  };

  useEffect(() => {
    const fn = () => {
      const { roles, context_title } = getCurFileInfoFromLocal();
      if (hasSubEd() && roles && roles === 'Learner') {
        window.onShowWarningMessage(isok => {
          if (isok) {
            return btnHandle();
          }
        }, {
          message: 'lmssubedTip',
          title: 'lmssubedTipTitle',
          ok: 'lmsunsubmit',
          closable: false,
          noCancel: true,
        });
      } else if (roles !== 'Learner') {
        updateFileByTeacher();

        const doShowAgain = localStorage.getItem('teacher_do_not_show_again') === 'true';
        if (doShowAgain) return;
        const cw = document.body.clientWidth;
        if (cw > 1000) return;
        window.onShowWarningMessage((isok, { checked }) => {
          if (isok) {
            localStorage.setItem('teacher_do_not_show_again', checked);
          }
        }, {
          message: 'suggestionTip',
          title: 'suggestionTitle',
          ok: 'Ok',
          closable: true,
          noCancel: true,
          iconType: 'alert',
          messageParams: { course: context_title },
          checkbox: {
            title: 'DoNotShowAgain',
            checked: false,
          },
        });
      }
    };

    const timer = setInterval(() => {
      if (!window.pdfui) return;
      clearInterval(timer);
      const DataEvents = UIExtension.PDFViewCtrl.PDF.DataEvents;
      window.pdfui.addViewerEventListener(DataEvents.docModified, fn);
    }, 1000);

    return () => {
      if (window.pdfui) {
        const DataEvents = UIExtension.PDFViewCtrl.PDF.DataEvents;
        window.pdfui.removeViewerEventListener(DataEvents.docModified, fn);
      }
    };
  }, []);

  return (<>
    {
      isStudent() ? (
        <Button className='lmsBtn' onClick={btnHandle} key={btnKey}>
          {getSubBtnTip()}
        </Button>
      ) : null
    }
  </>);
};

export default LMSSubBtn;
